import { HttpInterceptorFn } from '@angular/common/http'

export const sourceInterceptorFn: HttpInterceptorFn = (req, next) => {
    req = req.clone({
        setHeaders: { 'X-Request-Source': `Surefire SPA` },
    })
    return next(req)
}
